import { EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
var FcOutlinedInputComponent = /** @class */ (function () {
    function FcOutlinedInputComponent() {
        this.hideErrorTextEllipses = false;
        this.prefixIcon = null;
        this.next = new EventEmitter();
    }
    FcOutlinedInputComponent.prototype.ngOnInit = function () {
        if (this.isNumber) {
            this.inputType = 'number';
            return;
        }
        if (this.isPassword) {
            this.inputType = 'password';
            return;
        }
        this.inputType = 'text';
    };
    FcOutlinedInputComponent.prototype.changePasswordInputType = function () {
        this.inputType = this.inputType === 'text'
            ? 'password'
            : 'text';
    };
    return FcOutlinedInputComponent;
}());
export { FcOutlinedInputComponent };
